import { isNumber } from 'lodash-es';

export default function isNumberArray(arr: unknown[]): arr is number[] {
  return arr.every(isNumber);
}
